import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import en from "./locales/en";
import ko from "./locales/ko";

const fallbackLng = ['en'];
const availableLng = ['en', 'ko'];

const resources = {
	en: {
		translation: en
	},
	ko: {
		translation: ko
	}
};

i18n.use(initReactI18next).use(LanguageDetector).init({
	fallbackLng, debug: true, whitelist: availableLng,
	keySeparator: true,
	interpolation: {
		escapeValue: false
	},
	resources,
	react: {
		wait: true,
		useSuspense: false,
	},
	lng: 'en',
});

export default i18n;
